import { EditGroupDto } from '../../../dto/editgroup/editgroupdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface EditGroupRequest extends APIRequest
{
    getEditGroupRequest(): EditGroupDto;
}

export class EditGroupRequestImpl extends APIRequestDtoImpl implements EditGroupRequest
{
    constructor(private getEditGroupData: EditGroupDto)
    {
        super();
    }

    getEditGroupRequest(): EditGroupDto
    {
        return this.getEditGroupData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/editgrop/editgrouprequest.tsx